import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource/questrial';
import './index.css'; // Import the CSS file
import App from './App';

// Create root and render app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);